export default {
    props: {
        scaleLineColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.line.color'
        },
        scaleLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'scale.line.dashType'
        },
        scaleLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.line.visible'
        },
        scaleLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.line.width'
        },
        scaleLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.background'
        },
        scaleLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.border.color'
        },
        scaleLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.border.dashType'
        },
        scaleLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.border.width'
        },
        scaleLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.color'
        },
        scaleLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.font'
        },
        scaleLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.format'
        },
        scaleLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin'
        },
        scaleLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.top'
        },
        scaleLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.bottom'
        },
        scaleLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.left'
        },
        scaleLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.right'
        },
        scaleLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding'
        },
        scaleLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.top'
        },
        scaleLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.bottom'
        },
        scaleLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.left'
        },
        scaleLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.right'
        },
        scaleLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'scale.labels.template'
        },
        scaleLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.labels.visible'
        },
        scaleMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.majorTicks.color'
        },
        scaleMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'scale.majorTicks.size'
        },
        scaleMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.majorTicks.visible'
        },
        scaleMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.majorTicks.width'
        },
        scaleMajorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'scale.majorUnit'
        },
        scaleMax: {
            type: Number,
            default: undefined,
            kComposite: 'scale.max'
        },
        scaleMin: {
            type: Number,
            default: undefined,
            kComposite: 'scale.min'
        },
        scaleMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.minorTicks.color'
        },
        scaleMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'scale.minorTicks.size'
        },
        scaleMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.minorTicks.visible'
        },
        scaleMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.minorTicks.width'
        },
        scaleMinorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'scale.minorUnit'
        },
        scaleMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.mirror'
        },
        scaleRanges: {
            type: Array,
            default: undefined,
            kComposite: 'scale.ranges'
        },
        scaleRangePlaceholderColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.rangePlaceholderColor'
        },
        scaleRangeSize: {
            type: Number,
            default: undefined,
            kComposite: 'scale.rangeSize'
        },
        scaleReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.reverse'
        },
        scaleVertical: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.vertical'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/KendoLinearGauge/Scale.js